import React from "react";
import { storyblokEditable } from "gatsby-source-storyblok";
import { ProcessLink } from "../../global/helpers";
import Background from "../parts/background/background";

const CTABanner = ({ blok }) => {
    let link = ProcessLink(blok.cta_link);
    return (
        <section className="block_cta_banner content_block gs_reveal" {...storyblokEditable(blok)} key={blok._uid}>
            <Background blok={blok.background_settings} />
            <div className="inner">
                <div className="cta-container">
                        <div className="text">                            
                            <h2>
                                {blok.headline}
                                <span className="outline">
                                    {blok.headline_accent}
                                </span>
                            </h2>
                        </div>
                    <a href={link.url} data-fancybox={link.dataFancybox} data-src={typeof link.modalId !== undefined ? "#" + link.modalId : null} target={link.target} rel={link.rel} title={blok.cta_text} className={"cta-banner-link button primary " + link.cssClass} >
                        <span>{blok.cta_text}</span>
                        <div className='btn-bg top'></div>
                        <div className='btn-bg bottom'></div>
                    </a>
                    {typeof link.modal !== 'undefined' &&
                        link.modal
                    }
                </div>
            </div>
        </section>
    )
};

export default CTABanner;